import { render } from "./RecoveryDetailsSection.vue?vue&type=template&id=ec551930&scoped=true"
import script from "./RecoveryDetailsSection.vue?vue&type=script&lang=js"
export * from "./RecoveryDetailsSection.vue?vue&type=script&lang=js"

import "./RecoveryDetailsSection.vue?vue&type=style&index=0&id=ec551930&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec551930"],['__file',"src/components/RecoveryDetailsSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec551930"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec551930', __exports__)) {
    api.reload('ec551930', __exports__)
  }
  
  module.hot.accept("./RecoveryDetailsSection.vue?vue&type=template&id=ec551930&scoped=true", () => {
    api.rerender('ec551930', render)
  })

}


export default __exports__